export interface IntakeFormData {
    // Role / guardian
  intakeRole: 'candidate' | 'guardian' | '';
  guardianRelationship: '' | 'parent' | 'wali' | 'sibling' | 'friend' | 'other';
  candidateApprovesEveryIntro: boolean; // guardian-only, always true

  // Candidate controls (candidate-only)
  allowGuardianLedIntros: null | boolean;
  guardianIntroRoles: string[]; // ['parent','wali','sibling','friend','other']

  // Represented Candidate (guardian-only)
  rc_firstName: string;
  rc_age: string;
  rc_gender: 'male' | 'female' | '';
  rc_city: string;
  rc_languagesSpoken: Array<'en'|'fr'|'ar'|'ur'>;
  rc_languagesPreferred: Array<'en'|'fr'|'ar'|'ur'>;
  rc_otherLanguage: string;
  rc_otherLanguagePreferred: string;

  // Guardian spouse preferences (guardian-only; 1–7)
  pref_faith_role: number | null;
  pref_faith_ramadan: number | null;
  pref_faith_halal_food: number | null;
  pref_faith_halal_income: number | null;

  pref_fam_inlaws: number | null;
  pref_fam_parents_decisions: number | null;
  pref_fam_finances: number | null;

  pref_rel_conflict: number | null;
  pref_rel_openness: number | null;
  pref_rel_processing: number | null;

  pref_lifestyle_travel: number | null;
  pref_lifestyle_exercise: number | null;
  
  // Basics
  firstName: string;
  age: string;
  gender: 'male' | 'female' | '';
  city: string;
  inPerson: '' | 'yes' | 'maybe' | 'not_now';

  // Contact
  email: string;
  phone: string;

  // Photo (optional)
  photoFile?: File | null;        // client-only
  photoPreview?: string;          // client-only
  photo_path?: string | null;     // ✅ send to server

  // Meta (useful later; safe to include now)
  locale: 'en' | 'fr' | 'ar' | 'ur';
  intake_version: number;

  // Language
  languagesSpoken: Array<'en'|'fr'|'ar'|'ur'>;
  languagesPreferred: Array<'en'|'fr'|'ar'|'ur'>;
  otherLanguage: string;
  otherLanguagePreferred: string;

  // Lifestyle (1-7)
  lifestyle_activity: number | null;
  lifestyle_travel: number | null;
  lifestyle_vacation: number | null;
  lifestyle_exercise: number | null;
  lifestyle_diet: number | null;

  // Relationship (1-7)
  rel_romance: number | null;
  rel_conflict: number | null;
  rel_processing: number | null;
  rel_similarity: number | null;
  rel_openness: number | null;

  // Marriage & Family
  fam_marriage_age: number | null;
  fam_children_count: string;
  fam_finances: number | null;
  fam_inlaws: number | null;
  fam_parents_decisions: number | null;
  previouslyMarried: null | boolean;
  hasChildren: null | boolean;
  childrenLivingWith: '' | 'yes' | 'no' | 'some';
  openToMoreChildren: '' | 'yes' | 'no' | 'unsure';

  // Faith (1-7)
  faith_role: number | null;
  faith_children: number | null;
  faith_halal_food: number | null;
  faith_ramadan: number | null;
  faith_halal_income: number | null;

  // Denomination
  faith_denomination_importance: number | null;
  faith_denomination: '' | 'none' | 'sunni' | 'shia' | 'sufi' | 'salafi' | 'prefer_not' | 'other';
  faith_denomination_other: string;

  // Openness (1-7)
  open_long_distance: number | null;
  open_children_abroad: number | null;
  open_children_lang: number | null;
  open_financial_risk: number | null;
  open_financial_support: number | null;

  // Age Pref
  age_preferences: string[];

  // Reflection
  reflection: string;
}

export const initialFormData: IntakeFormData = {
  intakeRole: '',
  guardianRelationship: '',
  candidateApprovesEveryIntro: false,

  allowGuardianLedIntros: null,
  guardianIntroRoles: [],

  rc_firstName: '',
  rc_age: '',
  rc_gender: '',
  rc_city: '',
  rc_languagesSpoken: [],
  rc_languagesPreferred: [],
  rc_otherLanguage: '',
  rc_otherLanguagePreferred: '',

  pref_faith_role: null,
  pref_faith_ramadan: null,
  pref_faith_halal_food: null,
  pref_faith_halal_income: null,

  pref_fam_inlaws: null,
  pref_fam_parents_decisions: null,
  pref_fam_finances: null,

  pref_rel_conflict: null,
  pref_rel_openness: null,
  pref_rel_processing: null,

  pref_lifestyle_travel: null,
  pref_lifestyle_exercise: null,
  
  firstName: '',
  age: '',
  gender: '',
  city: '',
  inPerson: '',

  email: '',
  phone: '',
  locale: 'en',
  intake_version: 1,

  photoFile: null,
  photoPreview: '',
  photo_path: null,

  languagesSpoken: [],
  languagesPreferred: [],
  otherLanguage: '',
  otherLanguagePreferred: '',

  lifestyle_activity: null,
  lifestyle_travel: null,
  lifestyle_vacation: null,
  lifestyle_exercise: null,
  lifestyle_diet: null,

  rel_romance: null,
  rel_conflict: null,
  rel_processing: null,
  rel_similarity: null,
  rel_openness: null,

  fam_marriage_age: null,
  fam_children_count: '',
  fam_finances: null,
  fam_inlaws: null,
  fam_parents_decisions: null,
  previouslyMarried: null,
  hasChildren: null,
  childrenLivingWith: '',
  openToMoreChildren: '',

  faith_role: null,
  faith_children: null,
  faith_halal_food: null,
  faith_ramadan: null,
  faith_halal_income: null,

  faith_denomination_importance: null,
  faith_denomination: '',
  faith_denomination_other: '',

  open_long_distance: null,
  open_children_abroad: null,
  open_children_lang: null,
  open_financial_risk: null,
  open_financial_support: null,

  age_preferences: [],
  reflection: '',
};

export interface StepProps {
  data: IntakeFormData;
  updateData: (fields: Partial<IntakeFormData>) => void;
  onNext: () => void;
  onBack?: () => void;
}